/* stylelint-disable selector-max-compound-selectors, max-nesting-depth */

sew-ws-product-links {
    @include component-spacing;

    display: block;
    background-color: $color-grey-06-bright;
    padding: 48px 0 60px;

    .grid {
        @include grid;
    }

    .headline {
        @include typo-ws-h2;

        margin: 0;
    }

    .items {
        margin-top: 32px;
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .show-more-btn {
        all: unset;

        @include typo-ws-paragraph;

        color: $color-red;
        margin: 32px 0 0 24px;
        cursor: pointer;
    }

    sew-ws-product-links-item {
        display: none;
    }

    sew-ws-product-links-item:nth-of-type(-n + 5) {
        display: block;
    }

    @include mq-1 {
        padding: 32px 0 40px;

        .items {
            margin-top: 24px;
        }
    }

    &.expanded {
        sew-ws-product-links-item {
            display: block;
        }
    }
}
